import { useContext } from "react";
import './Header.css'
import { Container, Row, Stack } from "react-bootstrap";
import { ReactComponent as LivelyBlueLogo } from '../../../assets/logos/lively-bbyh-logo-blue.svg'
import { ReactComponent as PhoneIcon } from '../../../assets/icons/svg/phone.svg'
import LinkIcon from '../Icons/external-link.js'
import { useTranslation } from 'react-i18next';
import ConfigContext from '../../../context/configContext';

function Header() {
    const config = useContext(ConfigContext);
    const { t } = useTranslation();
    const livelyLink = `${config.ACCT_MGT_PORTING_FRONTEND}/myaccount/accountoverview`;

    const goToLively = () => {
        window.open(
            livelyLink,
            "_self"
        );
    }

    return (
        <>
            <Container fluid className="header-container">
                <Row className="header-top-container py-3 ps-1 ">
                    <Stack direction="horizontal">
                        <div onClick={goToLively} className="header-top-content header-top-content-left">
                            <LinkIcon color="#3191FC" width="20" height="20" />
                            <a href={livelyLink}
                            ><u>{t('header.lively_link')}</u></a>
                        </div>
                        <div className="header-top-content header-top-content-right ms-auto">
                            <div className='phone-icon'>
                                <PhoneIcon color="#3191FC" width="20" height="20" />
                            </div>

                            {t('header.need_help')}
                            <u>{t('lively_help_line')}</u>
                        </div>
                    </Stack>
                </Row>
                <Row>
                    <div className="header-bottom-container">
                        <div className="logo ps-2">
                            <LivelyBlueLogo />
                        </div>
                    </div>
                </Row>
            </Container>
        </>
  );
}

export default Header;
